import React from 'react';
import { Box, Button, Divider, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from 'react-router-dom';
import { LogoOnly } from '@shared/components/LogoOnly';

const useStyles = makeStyles((theme) => ({
    btn: {
        textTransform: 'none',
        fontWeight: 600
    }
}));

export const QuickLinks = () => {
    const classes = useStyles();
    return (
        <div>
            <Box width="100%">
                {/* <LogoOnly />
                <Box my={4}>
                    <>
                        <Typography variant="h5" >
                            Do you know our Marketplace?
                        </Typography>
                        <Typography >
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        </Typography>
                        <Button color="primary" className={classes.btn} component={Link} to="/marketplace">
                            Go To Marketplace &nbsp;&nbsp; <ArrowForwardIcon fontSize="small" />
                        </Button>
                    </>
                </Box>
                <Divider />
                <>
                    <Box my={2}>
                        <Typography variant="h5" >
                            My Favourite Stores
                        </Typography>
                        <Box display="flex" flexDirection="column" alignItems="start">
                            <Typography variant="h5" ></Typography>
                            <Button color="primary" className={classes.btn}>
                                The Spot &nbsp;&nbsp; <ArrowForwardIcon fontSize="small" />
                            </Button>
                            <Button color="primary" className={classes.btn}>
                                Liv Nightclub &nbsp;&nbsp; <ArrowForwardIcon fontSize="small" />
                            </Button>
                            <Button color="primary" className={classes.btn}>
                                Scarpetta&nbsp;&nbsp; <ArrowForwardIcon fontSize="small" />
                            </Button>
                        </Box>
                    </Box>
                    <Divider />
                </> */}
                <Box color="primary" >
                    <Typography className={'title3'} color={'#1E293B'} mb={1}>
                        Questions or problems with your Stakes Memberships?
                    </Typography>
                    <Typography fontWeight={500} className={'body2'} color={'#475569'} mb={2}>
                        Visit our Help Center to see the most frequently asked questions.
                    </Typography>
                    <Button color="primary"
                        style={{ padding: '0px' }}
                        component={Link}
                        to='/help-center'
                    >
                        <Typography fontWeight={700} className={'button-label'} color={'#041E42'} mr={1}>
                            Help Center
                        </Typography>
                        <ArrowForwardIcon fontSize="small" />
                    </Button>
                </Box>
            </Box>
        </div>
    )
}
